// Sentry desativado: o Sentry.init() abaixo esta comentado, e manter o import ativo
// puxava @sentry/angular para o grafo de compilacao sem uso. Para reativar, reponha
// `import * as Sentry from '@sentry/angular';` junto com o bloco Sentry.init().
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { System } from 'src/app/models/core-config.model';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Sentry.init({
//   environment: `${environment.env}-${environment.system}`,
//   dsn: 'https://3daef5c9d27bbd22be35be12ea215c64@o1323705.ingest.us.sentry.io/4506384395141120',
//   integrations: [Sentry.browserTracingIntegration()],
//   tracesSampleRate: 1,
//   enableLogs: true,
//   sendDefaultPii: true,
// });

enableProdMode();
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));

const title = environment.title;
const system = environment?.system;
if (title && system == System.TICKET_CENTER) {
  // Verificar se o título já tem contagem de notificações para preservar
  const currentTitle = document.title;
  const notificationMatch = currentTitle.match(/^\((\d+)\)\s*(.+)$/);

  if (notificationMatch) {
    // Preservar contagem de notificações
    document.title = `(${notificationMatch[1]}) ${title}`;
  } else if (title) {
    // Definir título normal
    document.title = title;
  }
}
